export class Common{
    constructor (){

    }
}